import { gql } from "@apollo/client"

export const DeleteStore = gql`
mutation DeleteStore($deleteStoreId: ID!) {
  deleteStore(id: $deleteStoreId) {
    status
  }
}
`